export default __webpack_public_path__ + "static/media/lineTypeZigzag.97862faa.svg";